<script>
import { mapGetters } from 'vuex'
import { WizardSteps } from '@/enums/WizardSteps'
import Wizard from '@/components/upload/Wizard.vue'
export default {
  components: { Wizard },
  data: () => ({
    orderId: undefined,
    order: null,
    stepMap: WizardSteps,
    loading: true,
    step: 1,
    steps: 4,
    wizardComponentKey: 0
  }),
  computed: {
    ...mapGetters(['locale']),
    pageHeader() {
      return this.$t(('navigation.views.upload.page.step.' + this.step))
    }
  },
  watch: {
    $route(to) {
      // if route 'upload' is called directly, set step to 1
      // workaround: if route is called from header or a other component without a param
      if (to.name === 'upload') {
        //TODO Test without Key!!!
        this.wizardComponentKey += 1 // force re-render the component
        this.step = 1
      }
    }
  },
  created: function () {
    this.step = Number(this.$route.params.step) || 1
    this.orderId = this.$route.params.orderId || undefined
    this.addEventListener()
    // take orderId from prop
    this.getOrder(this.orderId)

  },
  methods: {
    addEventListener: function () {
      this.$root.$off('onValidated')
      this.$root.$on('onValidated', orderId => {
        this.getOrder(orderId, false)
      })
      this.eventEnable = true
    },
    nextStep(params) {
      // response from caller
      if (params !== undefined) {
        // caller is Step-1 (UploadWrapper)
        if (params.originStep === 1) {
          // get order by orderId
          this.$router.push({
            name: 'uploadParams',
            params: {
              orderId: params.response.orderId,
              locale: this.locale
            }
          })
          this.getOrder(params.response.orderId)
          return
        }
        if (params.originStep === 2) {
          this.getOrder(params.response.orderId)
          return
        }
      }
      if (this.step < this.steps) {
        this.step += 1
        // set query for normal stepping (for example from step3 to step4)
        this.setRouterQuery(this.step)
      }
    },
    getOrder(orderId, redirectOnError = true) {
      // get step / status from orderId and validate
      if (orderId !== undefined) {
        this.$ordersService
        .getOrder(orderId)
        .then(order => {
          this.order = order
          this.orderId = order.orderId
          // is status in stepMap ?
          let wizardStep = this.stepMap.getKey(order.orderStatus)
          if (
            wizardStep !== undefined &&
            this.step !== this.stepMap[order.orderStatus]
          ) {
            // set step related to orderStatus if not already set
            this.step = this.stepMap[order.orderStatus]
            this.setRouterQuery(this.step)
          }
          this.loading = false
        })
        .catch(e => {
          // if something goes wrong, show the component with defaults
          // if response is not valid (reused url, but order is empty / deleted), redirect to step 1
          if (e.response.status === 404) {
            redirectOnError && this.setRouterQuery(1, 'upload')
          }
          this.loading = false
        })
      } else {
        // normal procedure
        this.loading = false
      }
    },
    setRouterQuery(step, name) {
      var pushParams = {}
      pushParams.name = name || this.routerName
      pushParams.params = {}
      pushParams.params.step = step
      pushParams.params.locale = this.locale
      pushParams.params.orderId = this.orderId
      this.$router.push(pushParams)
    }
  }
}
</script>
<template>
  <v-container :fluid="$vuetify.breakpoint.lgAndDown">
    <div v-if="loading">
      <h1 class="text-center primary--text pt-4 pb-4">
        {{ $t('navigation.views.upload.page.loading') }}
      </h1>
      <v-card loading>
        <v-card-text>
          <v-skeleton-loader class="mx-auto" type="card"></v-skeleton-loader>
        </v-card-text>
      </v-card>
    </div>
    <div v-if="!loading">
      <Wizard
        :key="wizardComponentKey"
        :step="step"
        :next-step="nextStep"
        :order="order"
      />
    </div>
  </v-container>
</template>
